<template>
  <vx-card :title="$t('reports.mental_health.WHY_JOINED.title')">
    <vs-row v-if="extractedData" vs-align="center" vs-justify="center">
      <vs-col vs-w="12">
        <ol>
          <li class="text-center" v-for="(data,index) in extractedData.data" :key="data.x">
            <h2 :style="{'color':extractedData.colors[index], 'font-size':fontSize(data.y) +'px'}" class="pt-3">
              <span>{{ data.x }}</span>
              <span :style="{ 'font-size':(fontSize(data.y) * .5) +'px'}" class="ml-3">({{ percentage(data.y) + '%' }})</span>
            </h2>
          </li>
        </ol>
        <!--        <vue-apex-charts height="200" type="bar" :options="extractedData.chartOptions" :series="extractedData.series"></vue-apex-charts>-->
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
export default {
  name: 'mental-health-why-joined-card',
  props: {
    data: Object
  },
  data () {
    return {
      extractedData: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const topStressors = allTime.nested.find(n => n.name === 'WHY_JOINED');
        const total = topStressors.buckets.map(b => b.count).reduce((a, b) => a + b, 0);
        this.extractedData = {
          total,
          colors: [
            '#28c76f',
            '#7ac442',
            '#97c12a',
            '#ccb700',
            '#ffa600',
            '#EA5455'
          ],
          data: topStressors.buckets.map(b => {
            return {
              x: b.key,
              y: b.count
            };
          })
        };
      }
    }
  },
  methods: {
    percentage (value) {
      return this.extractedData.total ? Math.round((value / this.extractedData.total) * 100).toFixed(1).replace(/\.0$/, '') : 100;
    },
    fontSize (value) {
      const min = 20;
      const max = 100;
      const scale = max - min;
      const fontSize = min + (this.percentage(value) / 100 * scale);
      return fontSize;
    }
  }
};
</script>

<style scoped>

</style>
